if (!customElements.get('blur-image')) {
  class BlurImage extends HTMLElement {
    connectedCallback() {
      const img = this.querySelector('[data-blur-image]');
      if (!img || (img.complete && img.naturalWidth > 0)) {
        this.markLoaded();
        return;
      }

      img.addEventListener('load', () => this.markLoaded(), { once: true });
      img.addEventListener('error', () => this.markLoaded(), { once: true });
    }

    markLoaded() {
      this.classList.add('is-loaded');
    }
  }

  customElements.define('blur-image', BlurImage);
}
